import { VideoReveal } from "./VideoReveal";
import { Eyebrow, Lines, Reveal } from "./Motion";
import { VIDEOS } from "@/lib/site";

const PAIRS = [
  {
    id: "exterior", tag: "New construction", title: "Bare slab to finished farmhouse", src: VIDEOS.exterior, start: 0,
    stages: ["Bare slab", "Framing", "Roof & siding", "Move-in ready"],
    scope: ["Foundation to finished exterior", "Board-and-batten siding with stone base", "Covered front porch & architectural roofline"],
  },
  {
    id: "interior", tag: "Interior finish-out", title: "Great room & kitchen finish", src: VIDEOS.interior, start: 0,
    stages: ["Drywall", "Cabinets & hood", "Floors & finishes", "Move-in ready"],
    scope: ["Vaulted ceiling with exposed beams", "Custom cabinetry & wood range hood", "Hardwood floors, sliders out to the deck"],
  },
];

const Pair = ({ p, i }) => (
  <div className="grid items-end gap-8 lg:grid-cols-12 lg:gap-12">
    <div className={`lg:col-span-8 ${i % 2 ? "lg:order-2" : ""}`}>
      <Reveal>
        <VideoReveal testId={`before-after-video-${p.id}`} src={p.src} start={p.start} stages={p.stages} alt={p.title} />
      </Reveal>
    </div>
    <Reveal delay={0.15} className="lg:col-span-4">
      <div className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-500">Project 0{i + 1} / {p.tag}</div>
      <h3 className="mt-4 font-display text-3xl font-bold tracking-tight text-neutral-50 md:text-4xl">{p.title}</h3>
      <ul className="mt-6 space-y-3 border-t border-white/[0.08] pt-6">
        {p.scope.map((s) => (
          <li key={s} className="flex items-center gap-3 text-neutral-300"><span className="h-1.5 w-1.5 shrink-0 bg-white" />{s}</li>
        ))}
      </ul>
      <div className="mt-8 flex flex-wrap gap-2">
        {p.stages.map((s, k) => (
          <span key={s} className="rounded-full border border-white/10 px-3 py-1.5 font-mono text-[0.6rem] uppercase tracking-[0.15em] text-neutral-400">
            <span className="mr-1.5 text-white">{String(k + 1).padStart(2, "0")}</span>{s}
          </span>
        ))}
      </div>
    </Reveal>
  </div>
);

export const Transformations = () => (
  <section id="transformations" data-testid="section-before-after" className="relative bg-[#121212] px-5 py-28 md:px-10 md:py-40">
    <div className="mx-auto max-w-[1500px]">
      <div className="mb-16 flex flex-col justify-between gap-8 md:mb-24 md:flex-row md:items-end">
        <div>
          <Eyebrow>Before / After</Eyebrow>
          <h2 className="mt-6 font-display text-4xl font-bold leading-[1] tracking-tighter text-neutral-50 md:text-6xl">
            <Lines lines={["Watch it", <span key="b" className="font-serif font-normal italic text-neutral-400">come together.</span>]} />
          </h2>
        </div>
        <p className="max-w-sm text-neutral-400">Real Newland builds, start to finish. Each reveal plays as you scroll in, fading from black-and-white to full color as the work comes together. Drag the timeline to scrub it yourself.</p>
      </div>
      <div className="space-y-24 md:space-y-32">
        {PAIRS.map((p, i) => <Pair key={p.id} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
